import * as React from 'react'
import {
  ColumnDef,
  createColumnHelper,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table'
import { FoundHourShape } from '../../api/api_data_types'

export default function useFoundHoursOverviewTable(foundHours: FoundHourShape[]) {
  const cellFunction = info => {
    const value = info.getValue()
    if (value === null || value === undefined) {
      return null
    }

    if (!isNaN(value)) {
      return value.toLocaleString('da-DK')
    }

    return value
  }

  const [data, setData] = React.useState(() => [...foundHours])

  const columns: ColumnDef<FoundHourShape>[] = React.useMemo(
    () => [
      { header: 'Afdeling', accessorKey: 'department.title', cell: cellFunction, enableColumnFilter: false, className: 'text-nowrap' },
      { header: 'Bruger', accessorKey: 'user.name', cell: cellFunction, enableColumnFilter: false },
      { header: 'Dato', accessorKey: 'date', cell: cellFunction, enableColumnFilter: false, className: 'text-nowrap' },
      { header: 'Type', accessorKey: 'saved_type', cell: cellFunction, enableColumnFilter: false },
      { header: 'Frekvens', accessorKey: 'frequency', cell: cellFunction, enableColumnFilter: false },
      { header: 'Tid', accessorKey: 'time', cell: cellFunction, enableColumnFilter: false, className: 'text-nowrap' },
      { header: 'Årlig effekt', accessorKey: 'time_for_year', cell: cellFunction, enableColumnFilter: false },
      { header: 'DKK', accessorKey: 'amount_dkk', cell: cellFunction, enableColumnFilter: false },
      { header: 'Årlig DKK', accessorKey: 'amount_dkk_for_year', cell: cellFunction, enableColumnFilter: false },
      { header: 'Beskrivelse', accessorKey: 'description', cell: cellFunction, enableColumnFilter: false },
      {
        header: 'Actions',
        accessorKey: 'actions',
        enableColumnFilter: false,
        enableSorting: false,
        className: 'text-nowrap',
        cell: ({ cell, row }) => {
          return (
            <div className="text-nowrap">
              <a href={`/found_hours/${row.original.id}/edit`} className="btn btn-sm btn-outline-primary">
                Rediger
              </a>
            </div>
          )
        }
      },
    ],
    [foundHours]
  )

  const table = useReactTable({
    data,
    columns,
    initialState: {
      sorting: [{ id: 'date', desc: true }],
      pagination: {
        pageIndex: 0,
        pageSize: 20,
      },
    },

    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  })

  return { table }
}
